// DS: B0
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import Add from '@wix/da-ds/pkg/Icons/24x24/Add';
import Add16 from '@wix/da-ds/pkg/Icons/16x16/Add';
import { useSubmitMenuItem } from '../../../hooks/useSubmitMenuItem';
import { submitButtonMenuItem } from '../../../constants';
import { Url } from '@wix/da-url';
const SubmitButton = ({ id, className })=>{
    const { t } = useTranslation();
    const isDsUpdate = useFlag('ds_update_btn_medium');
    const { href, biData, onClick: submitOnClick } = useSubmitMenuItem(_object_spread_props(_object_spread({}, submitButtonMenuItem), {
        link: Url.submitStudio(true)
    }));
    return /*#__PURE__*/ React.createElement(BrandedButton, {
        id: id,
        size: "medium",
        variant: "brand-green",
        icon: isDsUpdate ? Add16 : Add,
        className: className,
        href: href,
        onClick: submitOnClick,
        biData: biData
    }, t('siteHeader.submit'));
};
SubmitButton.displayName = 'SubmitButton';
export default SubmitButton;

//# sourceMappingURL=SubmitButton.js.map